import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import hervestLogo from "../../assets/images/hervest-logo.svg";
import { motion } from "framer-motion";

const HervestLoading = () => {
  return (
    <>
      <Transition.Root show={true} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-50 md:modalUp inset-0 overflow-y-auto"
          initialFocus={true}
          onClose={() => false}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="relative inline-block  md:mb-0 mb-80 rounded-lg text-center overflow-hidden shadow-xl transform transition-all align-middle  ">
                <div className=" sm:mt-0 text-left pt-4">
                  <Dialog.Title
                    as="h3"
                    className="px-4 flex flex-col"
                  ></Dialog.Title>
                  <div className="px-4 items-center flex-col p-5 w-24 rounded-xl bg-white flex-1 justify-center">
                    <motion.div
                      initial={{ scale: 0.8 }}
                      animate={{ scale: 1.2 }}
                      exit={{ scale: 0.8 }}
                      transition={{
                        repeat: Infinity,
                        duration: 1,
                        ease: "easeInOut",
                        repeatType: "reverse",
                      }}
                    >
                      <img
                        loading="lazy"
                        src={hervestLogo}
                        alt="hervest logo"
                      />
                    </motion.div>
                    <p className="text-sm mt-5">Loading...</p>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default HervestLoading;
